<template>
  <div class="content-box">
    <div class="content">
      <div class="title-box">
        <div class="title">
          <div class="title-text">大数据选址</div>
          <div class="title-e">BIG DATA LOCATION</div>
          <div class="title-line"></div>
        </div>
        <div class="end-rukou"></div>
      </div>
      <div class="describe">
        <p>
          基于极能充充电大数据平台的海量行业数据，对选定的建站地址进行智能分析，预测建站后充电车次，运营效率及投资回报率等，为充电站投资决策提供战略支撑。
        </p>
        <p>1.地区新能源车辆保有量</p>
        <p>2.用户增长速度</p>
        <p>3.地区交通出行数据</p>
        <p>4.地区土地数据</p>
        <p>5.周边竞对数据</p>
      </div>

      <div class="data-describe">
        <div class="data-box data-one">
          <div class="data-num">7<span class="min-span">天</span></div>
          <div class="data-synopsis">
            <p>快速选址最快选址</p>
            <p>只需7天</p>
          </div>
        </div>
        <div class="data-line data-line1"></div>
        <div class="data-box data02">
          <div class="data-num">5<span class="min-span">年</span></div>
          <div class="data-synopsis">
            <p>预计静态回收期</p>
            <p>5年以内</p>
          </div>
        </div>
        <div class="data-line data-line1"></div>
        <div class="data-box data03">
          <div class="data-num">13<span class="min-span">%</span></div>
          <div class="data-synopsis">
            <p>预计年化投资回报</p>
            <p>率13%以上</p>
          </div>
        </div>
      </div>
      <div class="img-describe img"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>
<style src="./i_public.less" lang="less" scoped></style>
<style lang="less" scoped>
/*.content-box{*/
/*width: 100%;*/
/*margin: 0px auto;*/
/*height: 100%;*/
/*background-color: #fff;*/
/*font-family:PingFangSC-Regular,PingFang SC;*/
/*.content{*/
/*width: 1200px;*/
/*height: 600px;*/
/*margin: 0px auto;*/
/*margin-top: 80px;*/
/*padding:20px;*/
/*position: relative;*/
/*.title-box{*/
/*display: flex;*/
/*justify-content: space-between;*/
/*font-size: 20px;*/
/*width: 1000px;*/
/*margin: 2% auto;*/
/*height: 66px;*/
/*text-align: left;*/
/*.title-text {*/
/*color: #05123E;*/
/*font-size: 30px;*/
/*font-weight: 500;*/
/*}*/
/*.title-e {*/
/*font-size: 10px;*/
/*color: #6684D0;*/
/*line-height: 30px;*/
/*letter-spacing: 1px;*/
/*}*/
/*.title-line {*/
/*background: linear-gradient(90deg,  #099AFF, #3AFEFE);*/
/*height: 2px;*/
/*width: 30px;*/
/*margin: 0 auto;*/
/*border-radius: 1px;*/
/*margin-left: 0;*/
/*}*/
/*.end-rukou{*/
/*font-size: 14px;*/
/*color: #19C1E7;*/
/*text-align: right;*/
/*line-height: 66px;*/
/*.icon-img{*/
/*background-image: url('./../../../assets/icon_next 2@2x.png');*/
/*display: inline-block;*/
/*width: 24px;*/
/*height: 24px;*/
/*background-repeat: no-repeat;*/
/*background-size: 24px 24px;*/
/*margin-bottom: -6px;*/
/*}*/
/*}*/
/*}*/
/*.describe{*/
/*width: 1000px;*/
/*margin: 0 auto;*/
/*text-align: left;*/
/*color: #526BAB;*/
/*font-size: 16px;*/
/*line-height: 30px;*/
/*}*/
/*.describe-characteristic{*/
/*width: 1000px;*/
/*margin: 14px auto;*/
/*text-align: left;*/
/*color: #1A3068;*/
/*font-size: 16px;*/
/*line-height: 28px;*/
/*.icon-img{*/
/*display: inline-block;*/
/*width: 24px;*/
/*height:24px;*/
/*margin-right: 6px;*/
/*background-repeat: no-repeat;*/
/*background-size: 24px 24px;*/
/*margin-bottom: -6px;*/
/*}*/
/*.icon1{*/
/*background-image: url('./../../../assets/icon_chongdian1_a@2x.png');*/
/*}*/
/*.icon2{*/
/*background-image: url('./../../../assets/icon_chongdian1_b@2x.png');*/
/*}*/
/*.icon3{*/
/*background-image: url('./../../../assets/icon_chongdian1_c@2x.png');*/
/*}*/
/*}*/
/*.data-describe{*/
/*width: 1000px;*/
/*margin: 20px auto;*/
/*display: flex;*/
/*.data-box{*/
/*width: 170px;*/
/*height:120px;*/
/*padding:10px;*/
/*.data-num{*/
/*color: #19C1E7;*/
/*font-size: 32px;*/
/*}*/
/*.data-synopsis{*/
/*font-size: 14px;*/
/*line-height: 10px;*/
/*font-family:PingFangSC-Regular,PingFang SC;*/
/*font-weight:400;*/
/*color:rgba(26,48,104,1);*/
/*}*/
/*}*/
/*.data-line{*/
/*min-width: 1px;*/
/*height: 50px;*/
/*background-color: #E6E9F3;*/
/*margin-top: 20px;*/
/*}*/

/*}*/
/*.img-describe{*/
/*height: 360px;*/
/*width: 376px;*/
/*background-image: url('./../../../assets/xuanzhi.gif');*/
/*background-repeat: no-repeat;*/
/*background-size: 80%;*/
/*position: absolute;*/
/*bottom: 80px;*/
/*right: 60px;*/
/*}*/
/*}*/
/*}*/

/*@media screen and (max-width: 1100px) {*/
/*.img-describe{*/
/*background-size: 60%!important;*/
/*right: -40px!important;*/
/*}*/
/*}*/
/*@media screen and (max-width: 1000px) {*/
/*.img-describe{*/
/*background-size:45%!important;*/
/*height: 260px;*/
/*width: 264px;*/
/*bottom: 70px!important;*/
/*right:-100px!important;*/
/*}*/
/*}*/
/*@media screen and (max-width: 800px) {*/
/*.img-describe{*/
/*display: none;*/
/*}*/
/*}*/
</style>